import { createFileRoute } from '@tanstack/react-router';
import { CampaignsNewRouteView } from '@/pages/workspaces/automations/routing';
import { validateCreateAutomationSearch } from '@/pages/workspaces/automations/new/search';
import { LastWorkspaceResolver } from './-components';

/** Creates an automation and opens it. No `appBundle`: this URL has no `journeys` segment. */
function AutomationsNewRoute() {
  const search = Route.useSearch();
  return (
    <LastWorkspaceResolver>
      <CampaignsNewRouteView search={search} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/new')({
  component: AutomationsNewRoute,
  validateSearch: validateCreateAutomationSearch,
});
